import { noop } from 'Helpers/PropTypes';
import { inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import React from 'react';
import { FDPrimaryActionButton, FDSecondaryActionButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

const ToggleButton = ({ option, value, onChange }) => {
  if (option.id === value) {
    return (
      <FDPrimaryActionButton
        key={option.id}
        label={option.prompt}
        size={'sm'}
        {...dataAttrs('selected-toggle-button')}
      />
    );
  }

  return (
    <FDSecondaryActionButton
      key={option.id}
      size={'sm'}
      label={option.prompt}
      onClick={() => {
        onChange(option.id);
      }}
      {...dataAttrs('non-selected-toggle-button')}
    />
  );
};

ToggleButton.defaultProps = {
  value: undefined,
  onChange: noop,
};

ToggleButton.propTypes = {
  option: inputPropTypes.option.isRequired,
  value: inputPropTypes.value,
  onChange: inputPropTypes.onChange,
};

export default ToggleButton;
